import React, { useEffect, useState } from 'react'
import Appbar from '../component/Appbar'
import { useDispatch, useSelector } from 'react-redux'
import Points from '../../../../assets/icon/points.png'
import moment from 'moment'
import Style from './history.module.scss'
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { getUserQuizAction } from '../../../../redux/user/getUserQuzHistory'

function History() {
    window.scrollTo(0, 0);
    const dispatch = useDispatch()
    const [userScreenWidth, setUserScreenWidth] = useState()

    const getUserQuiz = useSelector(state => state.getUserQuiz)
    const { loading } = getUserQuiz
    const [limit, setLimit] = useState(5)
    const [page, setPage] = useState(0)
    const [Data, setData] = useState([]);
    const [hasMore, setHasMore] = useState(false);

    useEffect(() => {
        setUserScreenWidth(window.innerWidth)
        nextHandler();

    }, [page])

    const nextHandler = async () => {
        let response = await dispatch(getUserQuizAction({ page: page, limit: limit }))
        if (response?.payload?.status === 200) {
            setData(prev => [...prev, ...response?.payload?.data]);
            setHasMore(response?.payload?.data.length >= limit)
        }

    }

    return (
        <>
            <Appbar />

            <div className={Style.main_div}>
                <div className={Style.history__heading}>
                    <h3>History</h3>
                </div>
                <div className={Style.historyCover}>
                    {loading ? <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}> <Box sx={{ width: "80vw ", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>

                        <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
                        <br />
                        <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
                        <br />
                        <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
                        <br />
                        <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />


                    </Box> </div> : Data.length > 0 ? Data.map((item, index) => (
                        <>

                            <div className={Style.history__card} key={index}>
                                <div className={Style.history__pic}>
                                    <img src={item?.challenge_id?.image} alt="icon" />
                                </div>
                                <div className={Style.history__details}>
                                    <div className={Style.top}>
                                        <div className={Style.name}>{(item?.challenge_id?.challenge_name.length > 11 && userScreenWidth < 360) ? item?.challenge_id?.challenge_name.substring(0, 11) + "..." : (item?.challenge_id?.challenge_name.length > 14 && userScreenWidth < 420) ? item?.challenge_id?.challenge_name.substring(0, 14) + "..." : item?.challenge_id?.challenge_name.substring(0, 18)}</div>
                                    </div>
                                    <div className={Style.middle}>{item?.challenge_id?.cat_id?.cat_name ? item?.challenge_id?.cat_id?.cat_name : 'Daily Reward'}</div>

                                    <div className={Style.bottom}>
                                        <div>
                                            Completed On&nbsp;{moment.utc(item.createdAt).local().format("Do MMM YY")}
                                        </div>
                                        <div>
                                            |
                                        </div>
                                        <div>
                                            {moment.utc(item.createdAt).local().format('h:mm a')}
                                        </div>
                                    </div>
                                </div>

                                <div className={Style.logo}>
                                    <div className={Style.logo_pic}>
                                        <img src={Points} alt="logo" />
                                    </div>
                                    <p className={Style.reward_pic}>{item?.reward.toPrecision(4)}</p>
                                </div>


                            </div>
                        </>
                    )) : <div className={Style.no__transaction}><h3>No history available</h3></div>}

                    {hasMore && <div className={Style.loadmore_box} onClick={() => setPage(page + 1)}>Load More</div>}


                </div>
                {/* <div className='bg_color bg_color_history' style={{ width: "100%", minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: 'center' }}>

                {loading ? 'Loading...' : Data?.length > 0 ? (
                    Data.map((item, index) => (
                        (item?.mission_id || item?.reward_type==2 || item?.reward_type==3)  && (
                            <div className="history__card" key={index}>
                                <div className="history__pic">
                                {item?.mission_id && <img src={item?.mission_id?.icon ? item?.mission_id?.icon : NA} alt="icon" />}
                                {item?.reward_type===2 && <img src={DailyStreak} alt="icon" />}
                                {item?.reward_type===3 && <img src={SpinIcon} alt="icon" />}
                                </div>
                                <div className="history__details">
                                    <div className="top">
                                        {item?.mission_id && <div className="name">{item?.mission_id?.title ? item?.mission_id?.title.substring(0, 18) : '---'}</div>}
                                        {item?.reward_type===2 && <div className="name">{'Daily Login'}</div>}
                                        {item?.reward_type===3 && <div className="name">{'Spinwheel'}</div>}
                                        <div className="logo">
                                            <div className="logo_pic">
                                                <img src={Points} width="20px" alt="logo" />
                                            </div>
                                            <div className="logo_name">{item.reward_amt}</div>
                                        </div>
                                    </div>
                                    <div className="middle">{item?.mission_id?.cat_id?.cat_name ? item?.mission_id?.cat_id?.cat_name : 'Daily Reward'}</div>
                                    <div className="bottom">
                                        <div>Completed On: {moment.utc(item.created_at).format("Do MMM YY")}</div>
                                        <div>|</div> 
                                        <div>{moment.utc(item.created_at).format('h:mm a')}</div>
                                    </div>
                                </div>
                            </div>
                        )
                    ))
                ) : (
                    <div className='no__transaction__history'><h3>No transaction history available</h3></div>
                )}


                {Data.length < DataLength && <div className='next__page'><p onClick={nextHandler}>View More <span>&rarr;</span></p></div>}
            </div> */}

            </div>



        </>
    )
}

export default History